export default {
  submit: "Submit",
  search: "Search",
  reset: "Reset",
  select: "Select",
  create: "Create",
  update: "Update",
  edit: "Edit",
  delete: "Delete",
  add: "Add",
  remove: "Remove",
  cancel: "Cancel",
  save: "Save",
  saved: "Saved",
  loading: "Loading...",
  error: "Error",
  success: "Success",
  warning: "Warning",
  info: "Information",
  date: "Date",
  time: "Time",
  today: "Today",
  yesterday: "Yesterday",
  tomorrow: "Tomorrow",
  lastDays: "Last {days} days",
  upgrade: "Upgrade",
  import: "Import",
  export: "Export",
  ok: "OK",
  close: "Close",
  clear: "Clear",
  retry: "Retry",
  upload: "Upload",
  row: "Row {row}",
  items: "items",
  yes: "Yes",
  no: "No",
  utc: "UTC",
  london: "London",
  paris: "Paris",
  berlin: "Berlin",
  shanghai: "Shanghai",
  new_york: "New York",
  los_angeles: "Los Angeles",
  privacy_policy: "View Privacy Policy",
  email_placeholder: "Please enter your email",
  empty_chart_action: "Calculate Now",
  preview: "Preview",
  sign_out: "Sign Out",
  invoice: "Invoice",
  credit_notes: "Credit Notes",
  filter: "Filter",
  trendChart: {
    export_image: "Export Image",
    this_month: "This Month",
    last_month: "Last Month",
    month_before_last: "Month Before Last",
    this_week: "This Week",
    last_2_weeks: "Last 2 Weeks",
    last_4_weeks: "Last 4 Weeks",
    today: "Today",
    yesterday: "Yesterday",
    day_before_yesterday: "Day Before Yesterday",
    month: "Month",
    week: "Week",
    day: "Day",
    export_failed: "Failed to export chart",
    export_retry: "Failed to export chart, please try again",
  },
  view_all_news: "View All News",
  confirm: "Confirm",
  rangeSearch: "Range Search",
  leg: {
    origin: "Origin",
    destination: "Destination",
    transportMode: "Transport Mode",
    distance: "Distance (km)",
    weight: "Weight (t)",
    cnCode: "CN Code",
    transportEmission: "Transport Emission (kg CO2e)",
    productionEmission: "Production Emission (kg CO2e)",
    totalEmission: "Total Emission (kg CO2e)",
  },
  previewReports: {
    pdfPreview: "PDF Preview",
    excelPreview: "Excel Preview",
    payPerUse: "Limit exceeded, pay per use?",
    payPerUseDownload: "Pay-per-use Download",
    download: "Download",
    refresh: "Refresh",
    darkModeWarning:
      "Dark mode is only for interface preview and does not affect exported files. Exported files will maintain a white background style",
    upgradeToUnlockExcel: "Upgrade to Pro to Unlock Excel Preview",
    unlockFeatures:
      "Unlock Excel export, custom Logo, multilingual and other advanced features to enhance report professionalism!",
    upgradeNow: "Upgrade Now",
    previewFailed: "Preview Failed",
    excelPreviewRequiresPro: "Excel preview requires a Pro subscription!",
    limitReached: "Daily or monthly limit reached",
    saved: "Saved successfully, you can view it in the report list",
  },
  select_status: "Select Status",
  select_plan_type: "Select Plan Type",
  refund: "Refund",
  view: "View",
  start_date: "Start Date",
  end_date: "End Date",
  view_details: "View Details",
  back_to_login: "Back to Login",
  view_count_description:
    "View count represents the total number of times this report has been viewed through sharing. Unsharing does not reset this count.",
  notify: {
    auto_renew: "Auto-Renewal",
    auto_renew_desc:
      "Enable to automatically renew your subscription at the end of the billing cycle.",
  },
  ticketTypes: {
    technical: "Technical Issue",
    billing: "Billing Issue",
    compliance: "Compliance Consultation",
    feedback: "Feedback and Suggestions",
    other: "Other",
  },
  loading_verification: "Loading verification...",
  billing: {
    current_plan: "Current Plan",
    upgrade: "Upgrade",
    manage: "View Billing",
    plan_type: "Plan Type",
    next_billing: "Next Billing Date",
    expiry_date: "Expiry Date",
    expired: "Expired",
    permanent: "Permanent",
  },
  faq: {
    search_placeholder: "Search FAQs...",
    no_results_title: "No results found",
    no_results_subtitle: "Try adjusting your search keywords or browse the categories on the left.",
    search_cleared_message: "Search cleared to show full content",
    still_have_questions: {
      before_email: "Still have questions? Contact us at ",
      after_email: " — our team will respond within 24 hours.",
    },
  },
};
